/**
 * Agent Commands API
 * 
 * Provides methods for sending commands to agents via MQTT through the backend.
 */

import { post } from './apiClient';
import { API_ROUTES } from '../shared/apiRoutes/apiRoutes';

/**
 * Trigger a config download on an agent
 * 
 * @param {string} agentId - Agent ID
 * @param {string} deviceIp - Device IP address
 * @param {string} username - Device username (default: 'admin')
 * @param {string} password - Device password (default: 'algo')
 * @returns {Promise<Object>} - Command response
 */
export async function triggerConfigDownload(agentId, deviceIp, username = 'admin', password = 'algo', deviceId = '', tenantId = '') {
  const url = API_ROUTES.AGENT_COMMAND.replace(':agentId', agentId);
  
  const payload = {
    action: 'config.download',
    deviceIp,
    username,
    password,
    deviceId,
    tenantId,
  };
  
  console.log(`[AgentCommands] Triggering config download for device ${deviceIp} via agent ${agentId}`);
  
  const response = await post(url, payload);
  
  if (!response.success) {
    throw new Error(response.message || response.error || 'Failed to trigger config download');
  }
  
  return response;
}

/**
 * Send a generic command to an agent
 * 
 * @param {string} agentId - Agent ID
 * @param {Object} commandPayload - Command payload
 * @returns {Promise<Object>} - Command response
 */
export async function sendAgentCommand(agentId, commandPayload) {
  const url = API_ROUTES.AGENT_COMMAND.replace(':agentId', agentId);
  
  console.log(`[AgentCommands] Sending command to agent ${agentId}:`, commandPayload);
  
  const response = await post(url, commandPayload);
  
  if (!response.success) {
    throw new Error(response.message || response.error || 'Failed to send command');
  }
  
  return response;
}

export default {
  triggerConfigDownload,
  sendAgentCommand,
};
